import React, { useState } from 'react';
import './App.css';

const heroImage = '/images/vahta.png';
const benefit1Image = '/images/benetif-new-1.png';
const benefit2Image = '/images/benefit-new-2.png';
const benefit3Image = '/images/benefit-new-3.png';

const WORK_REGIONS = [
    'Донецкая область',
    'Луганская область'
];

const PROFESSIONS = [
    {
        title: 'Водитель',
        description: 'доставка грузов по маршрутам на автомобилях КамАЗ, Урал, ГАЗель, УАЗ.',
        details: [
            'Перевозка грузов по установленным маршрутам',
            'Соблюдение правил дорожного движения и техники безопасности',
            'Контроль состояния автомобиля перед рейсом'
        ]
    },
    {
        title: 'Механик',
        description: 'ремонт транспортных средств КамАЗ, Урал, спецтехника.',
        details: [
            'Диагностика и ремонт грузовой и спецтехники',
            'Текущее техническое обслуживание и слесарные работы',
            'Подготовка транспорта к выезду в рейс'
        ]
    },
    {
        title: 'Сварщик',
        description: 'сварочные работы на объектах, металлоконструкциях и технике.',
        details: [
            'Сварка и ремонт металлоконструкций',
            'Работа с полуавтоматической и ручной сваркой',
            'Контроль качества швов и соблюдение техники безопасности'
        ]
    },
    {
        title: 'Охранник',
        description: 'охрана и сопровождение грузов автомобильными и железнодорожными колоннами, охранно-стационарных постов.',
        details: [
            'Охрана объектов и сопровождение грузов',
            'Работа на стационарных постах и в колоннах',
            'Контроль доступа и соблюдение регламента'
        ]
    },
    {
        title: 'Разнорабочий',
        description: 'обслуживание техники, покраска, заправка, помощь в ремонте.',
        details: [
            'Обслуживание и подготовка техники к работе',
            'Покраска, заправка, уборка территории',
            'Помощь механикам и водителям на объекте'
        ]
    }
];

const BENEFITS = [
    {
        image: benefit1Image,
        alt: 'Официальное трудоустройство',
        title: 'Официальное трудоустройство',
        description: 'Оформление по трудовому договору, белая заработная плата и социальные гарантии.'
    },
    {
        image: benefit2Image,
        alt: 'Проживание и питание',
        title: 'Проживание и питание за счёт компании',
        description: 'Проживание в вахтовых условиях и организованное питание на период работы.'
    },
    {
        image: benefit3Image,
        alt: 'Оплата больничных листов',
        title: 'Оплата больничных листов и пенсионных отчислений',
        description: 'Выплаты по больничным и пенсионные отчисления в соответствии с законодательством.'
    }
];

const App = () => {
    // Используем относительный путь для API в продакшене (через nginx proxy)
    // В разработке используем полный URL
    const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:5002');

    const [showForm, setShowForm] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [verificationId, setVerificationId] = useState(null);
    const [verificationStatus, setVerificationStatus] = useState('idle'); // idle | pending | verified | locked
    const [verificationMode, setVerificationMode] = useState('call'); // call | captcha
    const [verificationNumber, setVerificationNumber] = useState('');
    const [verificationNumberTel, setVerificationNumberTel] = useState('');
    const [captchaType, setCaptchaType] = useState('arithmetic'); // arithmetic | image
    const [captchaSessionId, setCaptchaSessionId] = useState(null);
    const [captchaQuestion, setCaptchaQuestion] = useState('');
    const [captchaAnswer, setCaptchaAnswer] = useState('');
    const [captchaChallengeUrl, setCaptchaChallengeUrl] = useState('');
    const [captchaOptions, setCaptchaOptions] = useState([]);
    const [captchaAttempts, setCaptchaAttempts] = useState(0);
    const [verifyStartLoading, setVerifyStartLoading] = useState(false);
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [verifyError, setVerifyError] = useState('');
    const [verifyLocked, setVerifyLocked] = useState(false);

    // Хранилище позиции скролла
    const scrollPositionRef = React.useRef(0);

    const buildCaptchaAssetUrl = (assetPath) => `${API_URL}${assetPath}`;

    const resetCaptchaState = () => {
        setCaptchaSessionId(null);
        setCaptchaQuestion('');
        setCaptchaAnswer('');
        setCaptchaChallengeUrl('');
        setCaptchaOptions([]);
        setCaptchaAttempts(0);
    };

    const applyCaptchaResponse = (data) => {
        setCaptchaSessionId(data.sessionId || null);

        if (data.captchaType === 'image') {
            setCaptchaType('image');
            setCaptchaChallengeUrl(data.challengeUrl ? buildCaptchaAssetUrl(data.challengeUrl) : '');
            setCaptchaOptions((data.options || []).map((option) => ({
                ...option,
                url: buildCaptchaAssetUrl(option.url)
            })));
            setCaptchaQuestion('');
            setCaptchaAnswer('');
            setCaptchaAttempts(0);
            return;
        }

        setCaptchaType('arithmetic');
        setCaptchaQuestion(data.question || '');
        setCaptchaAnswer('');
        setCaptchaChallengeUrl('');
        setCaptchaOptions([]);
        setCaptchaAttempts(0);
    };

    const resetVerificationLock = () => {
        setVerifyLocked(false);
        setVerificationStatus('idle');
        setVerifyError('');
        resetCaptchaState();
    };

    const handleRetryAfterBlock = async () => {
        try {
            const response = await fetch(`${API_URL}/api/verify/ip-status`);
            const data = await response.json();

            if (data.blocked) {
                const minutes = data.remainingMinutes || 1;
                setVerifyError(`Слишком много попыток. Попробуйте снова через ${minutes} мин.`);
                return;
            }

            resetVerificationLock();
        } catch (error) {
            console.error('IP status check error:', error);
            setVerifyError('Не удалось проверить статус блокировки. Проверьте соединение и попробуйте снова.');
        }
    };

    // Загрузка режима верификации при открытии формы
    React.useEffect(() => {
        if (showForm) {
            fetch(`${API_URL}/api/verify/mode`)
                .then(res => res.json())
                .then(data => {
                    if (data.mode) {
                        setVerificationMode(data.mode);
                    }
                    if (data.captchaType) {
                        setCaptchaType(data.captchaType);
                    }
                    if (data.verificationNumber) {
                        setVerificationNumber(data.verificationNumber);
                    }
                    if (data.verificationNumberTel) {
                        setVerificationNumberTel(data.verificationNumberTel);
                    }
                })
                .catch(err => {
                    console.error('Error fetching verification mode:', err);
                });
        }
    }, [showForm, API_URL]);

    // Автопроверка статуса входящего звонка на сервисный номер
    React.useEffect(() => {
        if (!showForm || verificationMode !== 'call' || verificationStatus !== 'pending' || !verificationId) {
            return undefined;
        }

        let cancelled = false;

        const pollStatus = async () => {
            try {
                const response = await fetch(`${API_URL}/api/verify/status/${verificationId}`);
                const data = await response.json();
                if (cancelled || !response.ok) return;

                if (data.verificationNumberDisplay || data.verificationNumber) {
                    setVerificationNumber(data.verificationNumberDisplay || data.verificationNumber);
                    setVerificationNumberTel(data.verificationNumberTel || data.verificationNumber || '');
                }

                if (data.status === 'verified') {
                    setVerificationStatus('verified');
                    setVerifyError('');
                }
            } catch (error) {
                console.error('Verify status poll error:', error);
            }
        };

        pollStatus();
        const timer = setInterval(pollStatus, 2500);

        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [showForm, verificationMode, verificationStatus, verificationId, API_URL]);

    // Блокировка скролла body при открытии модалки
    React.useEffect(() => {
        if (showForm) {
            // Сохраняем текущую позицию скролла
            scrollPositionRef.current = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
            // Блокируем скролл
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollPositionRef.current}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
        } else {
            // Восстанавливаем скролл
            const savedScrollPosition = scrollPositionRef.current;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            // Восстанавливаем позицию скролла после небольшой задержки, чтобы стили применились
            setTimeout(() => {
                window.scrollTo(0, savedScrollPosition);
            }, 0);
        }

        // Cleanup при размонтировании
        return () => {
            if (!showForm) {
                document.body.style.position = '';
                document.body.style.top = '';
                document.body.style.width = '';
                document.body.style.overflow = '';
            }
        };
    }, [showForm]);
    const [formData, setFormData] = useState({
        name: '',
        phone: '+7',
        city: '',
        profession: 'Водитель'
    });

    // Валидация номера телефона
    const validatePhone = (phone) => {
        // Удаляем все пробелы, дефисы и скобки
        const cleanedPhone = phone.replace(/[\s\-()]/g, '');

        if (!cleanedPhone) {
            return { valid: false, error: 'Телефон обязателен для заполнения' };
        }

        // Проверяем, что остались только цифры и может быть + в начале
        const phoneRegex = /^\+?[0-9]+$/;
        if (!phoneRegex.test(cleanedPhone)) {
            return { valid: false, error: 'Телефон может содержать только цифры и знак + в начале' };
        }

        // Извлекаем только цифры (убираем + если есть)
        const digitsOnly = cleanedPhone.replace(/^\+/, '');

        // Проверяем, начинается ли с 7 или 8
        const startsWith7or8 = digitsOnly.startsWith('7') || digitsOnly.startsWith('8');

        if (startsWith7or8) {
            // Для номеров, начинающихся с 7 или 8, должно быть минимум 11 цифр
            if (digitsOnly.length < 11) {
                return { valid: false, error: 'Телефон должен содержать минимум 11 цифр (включая 7 или 8)' };
            }
            if (digitsOnly.length > 15) {
                return { valid: false, error: 'Телефон не должен превышать 15 цифр' };
            }
        } else {
            // Для других номеров минимум 10 цифр
            if (digitsOnly.length < 10) {
                return { valid: false, error: 'Телефон должен содержать минимум 10 цифр' };
            }
            if (digitsOnly.length > 15) {
                return { valid: false, error: 'Телефон не должен превышать 15 цифр' };
            }
        }

        return { valid: true, error: '' };
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setError('');

        // Валидация телефона перед отправкой
        const phoneValidation = validatePhone(formData.phone);
        if (!phoneValidation.valid) {
            setPhoneError(phoneValidation.error);
            setLoading(false);
            return;
        }

        // Проверка верификации в зависимости от режима
        if (verificationStatus !== 'verified') {
            const errorMessage = verificationMode === 'captcha'
                ? 'Подтвердите заявку (решите капчу) перед отправкой'
                : 'Подтвердите номер телефона перед отправкой заявки';
            setError(errorMessage);
            setLoading(false);
            return;
        }

        if (verificationMode === 'call' && !verificationId) {
            setError('Подтвердите номер телефона перед отправкой заявки');
            setLoading(false);
            return;
        }

        if (verificationMode === 'captcha' && !captchaSessionId) {
            setError('Подтвердите заявку (решите капчу) перед отправкой');
            setLoading(false);
            return;
        }

        try {
            const submitData = {
                ...formData,
                verificationId: verificationMode === 'call' ? verificationId : null,
                captchaSessionId: verificationMode === 'captcha' ? captchaSessionId : null
            };

            const response = await fetch(`${API_URL}/api/submit`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(submitData),
            });

            const data = await response.json();

            if (!response.ok) {
                setError(data.error || 'Ошибка при отправке формы');
                setLoading(false);
                return;
            }

            setFormSubmitted(true);
            setLoading(false);
            setVerifyError('');
            setVerifyLocked(false);
            setVerificationStatus('idle');
            setVerificationId(null);
            setVerificationNumber('');
            setVerificationNumberTel('');
            resetCaptchaState();
        } catch (error) {
            console.error('Submit error:', error);
            setError('Ошибка соединения. Проверьте интернет.');
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        // Для телефона защищаем +7 от удаления
        if (name === 'phone') {
            let phoneValue = value;

            // Всегда сохраняем +7 в начале
            if (phoneValue.length === 0) {
                phoneValue = '+7';
            } else if (!phoneValue.startsWith('+7')) {
                // Если значение не начинается с +7, исправляем
                if (phoneValue.startsWith('+')) {
                    // Если начинается с +, но не с +7
                    const afterPlus = phoneValue.slice(1);
                    if (afterPlus.startsWith('7')) {
                        // Если после + идет 7
                        phoneValue = '+7' + afterPlus.slice(1);
                    } else {
                        // Если после + идет не 7, заменяем на +7
                        phoneValue = '+7' + afterPlus.replace(/^7?/, '');
                    }
                } else if (phoneValue.startsWith('7')) {
                    // Если начинается с 7 (без +)
                    phoneValue = '+7' + phoneValue.slice(1);
                } else {
                    // Если не начинается ни с +, ни с 7
                    // Удаляем любые + или 7 в начале и добавляем +7
                    phoneValue = '+7' + phoneValue.replace(/^\+?7?/, '');
                }
            }

            setFormData(prev => ({
                ...prev,
                [name]: phoneValue
            }));

            // Сброс состояния подтверждения при изменении телефона
            // НЕ сбрасываем verificationMode - он должен оставаться таким, каким был загружен с сервера
            setVerificationId(null);
            setVerificationStatus('idle');
            setVerificationNumber('');
            setVerificationNumberTel('');
            resetCaptchaState();
            setVerifyError('');
            setVerifyLocked(false);

            // Валидация телефона в реальном времени
            const validation = validatePhone(phoneValue);
            setPhoneError(validation.error);
        } else {
            setFormData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };

    const handleStartVerify = async () => {
        setVerifyError('');
        setVerifyLocked(false);

        const phoneValidation = validatePhone(formData.phone);
        if (!phoneValidation.valid) {
            setPhoneError(phoneValidation.error);
            return;
        }

        setVerifyStartLoading(true);

        try {
            const response = await fetch(`${API_URL}/api/verify/start`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone: formData.phone }),
            });

            const data = await response.json();

            if (!response.ok) {
                const errText = data.error || 'Не удалось запустить подтверждение';
                setVerifyError(errText);
                if (response.status === 429 || data.blocked) {
                    setVerifyLocked(true);
                    setVerificationStatus('locked');
                }
                setVerifyStartLoading(false);
                return;
            }

            if (data.mode === 'captcha') {
                setVerificationMode('captcha');
                setVerifyLocked(false);
                applyCaptchaResponse(data);
                setVerificationStatus('pending');
            } else {
                if (data.mode) {
                    setVerificationMode(data.mode);
                }
                setVerificationId(data.verificationId || null);
                setVerificationNumber(data.verificationNumberDisplay || data.verificationNumber || '');
                setVerificationNumberTel(data.verificationNumberTel || data.verificationNumber || '');
                setVerificationStatus('pending');
            }
        } catch (error) {
            console.error('Start verify error:', error);
            setVerifyError('Ошибка соединения. Проверьте интернет.');
        } finally {
            setVerifyStartLoading(false);
        }
    };

    const handleImageCaptchaSelect = async (selectedIndex) => {
        if (!captchaSessionId || verifyLoading || verifyLocked) {
            return;
        }

        setVerifyError('');
        setVerifyLoading(true);

        try {
            const response = await fetch(`${API_URL}/api/verify/check`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    sessionId: captchaSessionId,
                    selectedIndex
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                const errText = data.error || 'Ошибка проверки капчи';
                setVerifyError(errText);
                if (data.blocked || response.status === 429 || errText.toLowerCase().includes('10 минут')) {
                    setVerifyLocked(true);
                    setVerificationStatus('locked');
                }
                setVerifyLoading(false);
                return;
            }

            setVerificationStatus('verified');
            setVerifyLoading(false);
        } catch (error) {
            console.error('Verify image captcha error:', error);
            setVerifyError('Ошибка соединения. Проверьте интернет.');
            setVerifyLoading(false);
        }
    };

    const handleVerifyPin = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        setVerifyError('');
        setVerifyLocked(false);

        if (verificationMode === 'captcha' && captchaType === 'arithmetic') {
            if (!captchaSessionId) {
                setVerifyError('Не удалось найти сессию капчи. Запустите проверку заново.');
                return;
            }

            const answerNum = parseInt(captchaAnswer.trim(), 10);
            if (isNaN(answerNum) || captchaAnswer.trim() === '') {
                setVerifyError('Введите ответ на капчу');
                return;
            }

            setVerifyLoading(true);

            try {
                const response = await fetch(`${API_URL}/api/verify/check`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        sessionId: captchaSessionId,
                        answer: answerNum
                    }),
                });

                const data = await response.json();

                if (!response.ok) {
                    const errText = data.error || 'Ошибка проверки капчи';
                    setVerifyError(errText);
                    if (data.attemptsLeft !== undefined) {
                        setCaptchaAttempts(3 - data.attemptsLeft);
                    }
                    if (data.blocked || errText.toLowerCase().includes('превышено количество попыток')) {
                        setVerifyLocked(true);
                        setVerificationStatus('locked');
                    }
                    setVerifyLoading(false);
                    return;
                }

                setVerificationStatus('verified');
                setVerifyLoading(false);
            } catch (error) {
                console.error('Verify captcha error:', error);
                setVerifyError('Ошибка соединения. Проверьте интернет.');
                setVerifyLoading(false);
            }
            return;
        }

        // Режим звонка подтверждается автоматически через polling /status
    };

    const isPhoneValid = validatePhone(formData.phone).valid && !phoneError;

    const handlePhoneKeyDown = (e) => {
        const input = e.target;
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;

        // Запрещаем удаление первых двух символов (+7)
        if (selectionStart < 2 || selectionEnd < 2) {
            // Если пользователь пытается удалить или изменить первые два символа
            if (e.key === 'Backspace' || e.key === 'Delete') {
                e.preventDefault();
                // Устанавливаем курсор после +7
                setTimeout(() => {
                    input.setSelectionRange(2, 2);
                }, 0);
            } else if (e.key.length === 1 && selectionStart < 2 && !e.ctrlKey && !e.metaKey) {
                // Если пользователь пытается ввести символ перед +7 (но не Ctrl/Cmd)
                e.preventDefault();
                // Вставляем символ после +7
                const currentValue = input.value;
                const newValue = '+7' + e.key + currentValue.slice(2);
                setFormData(prev => ({
                    ...prev,
                    phone: newValue
                }));
                setTimeout(() => {
                    input.setSelectionRange(3, 3);
                }, 0);
            }
        }
    };

    const handlePhonePaste = (e) => {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        const input = e.target;
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;
        const currentValue = input.value;

        // Сохраняем +7 в начале, заменяем выделенный текст вставленным
        let newValue;
        if (selectionStart < 2) {
            // Если выделение включает +7, вставляем после +7
            newValue = '+7' + pastedText + currentValue.slice(Math.max(2, selectionEnd));
        } else {
            // Если выделение не включает +7, заменяем только выделенную часть
            newValue = currentValue.slice(0, selectionStart) + pastedText + currentValue.slice(selectionEnd);
        }

        // Применяем обработку, чтобы убедиться, что +7 остается в начале
        // Используем handleInputChange логику
        if (!newValue.startsWith('+7')) {
            if (newValue.startsWith('+')) {
                const afterPlus = newValue.slice(1);
                if (afterPlus.startsWith('7')) {
                    newValue = '+7' + afterPlus.slice(1);
                } else {
                    newValue = '+7' + afterPlus.replace(/^7?/, '');
                }
            } else if (newValue.startsWith('7')) {
                newValue = '+7' + newValue.slice(1);
            } else {
                newValue = '+7' + newValue.replace(/^\+?7?/, '');
            }
        }

        setFormData(prev => ({
            ...prev,
            phone: newValue
        }));

        const validation = validatePhone(newValue);
        setPhoneError(validation.error);

        // Устанавливаем курсор в конец вставленного текста
        setTimeout(() => {
            const newPosition = Math.min(selectionStart + pastedText.length, newValue.length);
            input.setSelectionRange(newPosition, newPosition);
        }, 0);
    };

    const handlePhoneBlur = (e) => {
        // При потере фокуса убеждаемся, что телефон начинается с +7
        let phoneValue = e.target.value;
        if (!phoneValue.startsWith('+7')) {
            if (phoneValue === '' || phoneValue === '+') {
                phoneValue = '+7';
            } else if (phoneValue.startsWith('7')) {
                phoneValue = '+' + phoneValue;
            } else if (phoneValue.startsWith('+')) {
                phoneValue = '+7' + phoneValue.slice(1);
            } else {
                phoneValue = '+7' + phoneValue;
            }
            setFormData(prev => ({
                ...prev,
                phone: phoneValue
            }));
            const validation = validatePhone(phoneValue);
            setPhoneError(validation.error);
        }
    };

    return (
        <div className="app">
            {/* Hero Section */}
            <section className="hero">
                <div className="container">
                    <div className="hero-content">
                        <div className="hero-left">
                            <h1 className="hero-title">
                                Работа вахтой<br />
                                ЗП от 320&nbsp;000 до 710&nbsp;000 руб. в месяц
                            </h1>
                            <p className="hero-lead">Стабильная занятость</p>
                            <p className="hero-lead-sub">Официальное оформление</p>

                            <div className="hero-info">
                                <p className="info-text">
                                    Требуются:{' '}
                                    {PROFESSIONS.map(({ title }, index) => (
                                        <span key={title}>
                                            {index > 0 && ', '}
                                            <span className="profession-name">{title}</span>
                                        </span>
                                    ))}
                                </p>
                            </div>

                            <button className="cta-button" onClick={() => setShowForm(true)}>
                                Подать заявку
                            </button>
                        </div>
                        <div className="hero-right">
                            <img src={heroImage} alt="Работа вахтой" className="hero-image" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Location Section */}
            <section className="location">
                <div className="container">
                    <h2 className="location-heading">Работа в регионах:</h2>
                    <ul className="location-regions-list">
                        {WORK_REGIONS.map((region) => (
                            <li key={region}>{region}</li>
                        ))}
                    </ul>
                    <p className="location-note">ПРОЕЗД К МЕСТУ РАБОТЫ ОПЛАЧИВАЕТ КОМПАНИЯ</p>
                    <p className="location-bonus-note">ВЫПЛАЧИВАЮТСЯ ПОДЪЁМНЫЕ</p>
                    <p className="location-bonus-note">ПРИ ТРУДОУСТРОЙСТВЕ</p>
                </div>
            </section>

            <section className="professions-section">
                <div className="container">
                    <h2 className="section-title">Вакансии</h2>
                    <div className="professions-grid">
                        {PROFESSIONS.map(({ title, description, details }) => (
                            <article key={title} className="profession-card">
                                <h3 className="profession-card-title">{title}</h3>
                                <p className="profession-card-desc">{description}</p>
                                <ul className="profession-card-details">
                                    {details.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            {/* Benefits Section */}
            <section className="benefits">
                <div className="container">
                    <h2 className="section-title">Преимущества компании</h2>
                    <p className="section-lead">
                        Условия для комфортной работы и уверенности в завтрашнем дне.
                    </p>
                    <div className="benefits-grid">
                        {BENEFITS.map(({ image, alt, title, description }) => (
                            <div key={title} className="benefit-card benefit-card-image">
                                <img src={image} alt={alt} />
                                <div className="benefit-overlay">
                                    <h3>{title}</h3>
                                    <p>{description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <h2 className="cta-title">Готовы присоединиться?</h2>
                    <p className="cta-lead">
                        Оставьте заявку — перезвоним, расскажем условия по выбранной вакансии и ответим на вопросы.
                    </p>
                    <button className="cta-button-large" onClick={() => setShowForm(true)}>
                        ПОДАТЬ ЗАЯВКУ
                    </button>
                </div>
            </section>

            {/* Form Modal */}
            {showForm && (
                <div className="modal-overlay" onClick={() => !formSubmitted && setShowForm(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        {verifyLocked && (
                            <div className="lock-overlay">
                                <div className="lock-modal">
                                    <h3>Подтверждение не пройдено</h3>
                                    <p>
                                        {verifyError || (captchaType === 'image'
                                            ? 'Неверный выбор картинки. Повторная попытка будет доступна через 10 минут.'
                                            : 'Превышено количество попыток ввода кода. Попробуйте позже или используйте другой номер.')}
                                    </p>
                                    <button
                                        type="button"
                                        className="submit-button"
                                        style={{ marginTop: '16px' }}
                                        onClick={handleRetryAfterBlock}
                                    >
                                        Попробовать снова
                                    </button>
                                </div>
                            </div>
                        )}
                        {!formSubmitted ? (
                            <>
                                <button className="modal-close" onClick={() => {
                                    setShowForm(false);
                                    setPhoneError('');
                                    setError('');
                                    setVerifyError('');
                                    setVerificationId(null);
                                    setVerificationNumber('');
                                    setVerificationNumberTel('');
                                    setVerificationStatus('idle');
                                    resetCaptchaState();
                                    setVerifyLocked(false);
                                    setFormSubmitted(false);
                                }}>×</button>
                                <h2 className="modal-title">Оставить заявку</h2>
                                <p className="modal-subtitle">Введите данные ниже, мы вам перезвоним</p>

                                <form onSubmit={handleSubmit} className="application-form">
                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Ваше имя"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="Ваш телефон"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            onKeyDown={handlePhoneKeyDown}
                                            onPaste={handlePhonePaste}
                                            onBlur={handlePhoneBlur}
                                            className={`form-input ${phoneError ? 'form-input-error' : ''}`}
                                            required
                                        />
                                        {phoneError && (
                                            <div className="form-field-error">{phoneError}</div>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <input
                                            type="text"
                                            name="city"
                                            placeholder="Ваш город"
                                            value={formData.city}
                                            onChange={handleInputChange}
                                            className="form-input"
                                            required
                                        />
                                    </div>

                                    {verificationStatus === 'verified' && (
                                        <div className="form-note" style={{ color: '#2e7d32', fontWeight: 600 }}>
                                            {verificationMode === 'captcha' ? 'Капча решена верно. Можно отправить заявку.' : 'Телефон подтверждён. Можно отправить заявку.'}
                                        </div>
                                    )}

                                    {verificationStatus !== 'verified' && verificationStatus !== 'pending' && (
                                        <div className="form-group">
                                            <button
                                                type="button"
                                                className="submit-button"
                                                onClick={handleStartVerify}
                                                disabled={
                                                    !isPhoneValid ||
                                                    verifyStartLoading ||
                                                    verificationStatus === 'pending' ||
                                                    verificationStatus === 'locked'
                                                }
                                            >
                                                {verifyStartLoading ? 'Запускаем проверку...' : verificationMode === 'captcha' ? 'Подтвердить заявку' : 'Подтвердить номер'}
                                            </button>
                                            <p className="form-note">
                                                {verificationMode === 'captcha'
                                                    ? 'Подтвердите заявку (решите капчу), чтобы отправить заявку.'
                                                    : 'Подтвердите номер, чтобы отправить заявку. Мы покажем номер, на который нужно позвонить.'}
                                            </p>
                                        </div>
                                    )}

                                    {verificationStatus === 'pending' && verificationMode === 'captcha' && captchaType === 'image' && (
                                        <div className="application-form image-captcha-form">
                                            <div className="captcha-label">Если вы человек, нажмите на похожую картинку</div>
                                            {captchaChallengeUrl && (
                                                <div className="captcha-challenge-wrap">
                                                    <img
                                                        src={captchaChallengeUrl}
                                                        alt="Эталонное изображение"
                                                        className="captcha-challenge-image"
                                                    />
                                                </div>
                                            )}
                                            <div className="captcha-options-grid">
                                                {captchaOptions.map((option, index) => (
                                                    <button
                                                        key={`${option.id}-${index}`}
                                                        type="button"
                                                        className="captcha-option-button"
                                                        onClick={() => handleImageCaptchaSelect(index)}
                                                        disabled={verifyLoading || verifyLocked}
                                                    >
                                                        <img
                                                            src={option.url}
                                                            alt={`Вариант ${index + 1}`}
                                                            className="captcha-option-image"
                                                        />
                                                    </button>
                                                ))}
                                            </div>
                                            {verifyError && <div className="form-error">{verifyError}</div>}
                                        </div>
                                    )}

                                    {verificationStatus === 'pending' && verificationMode === 'captcha' && captchaType === 'arithmetic' && (
                                        <div className="application-form" style={{ marginTop: '10px' }}>
                                            <div className="form-group">
                                                <div className="captcha-label">Решите пример</div>
                                                <div className="captcha-question">{captchaQuestion} = ?</div>
                                                {captchaAttempts > 0 && captchaAttempts < 3 && !verifyLocked && (
                                                    <div className="captcha-attempts-warning">
                                                        Осталось попыток: {3 - captchaAttempts}
                                                    </div>
                                                )}
                                                <input
                                                    type="number"
                                                    name="captcha"
                                                    placeholder="Введите ответ"
                                                    value={captchaAnswer}
                                                    onChange={(e) => setCaptchaAnswer(e.target.value)}
                                                    className="form-input"
                                                    inputMode="numeric"
                                                    required
                                                    disabled={verifyLocked}
                                                />
                                            </div>
                                            {verifyError && <div className="form-error">{verifyError}</div>}
                                            <button
                                                type="button"
                                                className="submit-button"
                                                disabled={verifyLoading || verifyLocked}
                                                onClick={handleVerifyPin}
                                            >
                                                {verifyLoading ? 'Проверяем...' : 'Подтвердить ответ'}
                                            </button>
                                        </div>
                                    )}

                                    {verificationStatus === 'pending' && verificationMode === 'call' && (
                                        <div className="verify-call-box">
                                            <div className="captcha-label">Позвоните на номер</div>
                                            {verificationNumberTel ? (
                                                <a href={`tel:${verificationNumberTel}`} className="verify-call-number">
                                                    {verificationNumber || verificationNumberTel}
                                                </a>
                                            ) : (
                                                <div className="verify-call-number">
                                                    {verificationNumber || 'номер загружается...'}
                                                </div>
                                            )}
                                            <p className="verify-call-wait">
                                                Звоните именно с того телефона, который указали в заявке.
                                                После звонка статус подтвердится автоматически.
                                            </p>
                                            {verifyError && <div className="form-error">{verifyError}</div>}
                                        </div>
                                    )}

                                    <div className="form-group">
                                        <label htmlFor="profession">Выберите один из вариантов</label>
                                        <div className="select-wrapper">
                                            <select
                                                id="profession"
                                                name="profession"
                                                value={formData.profession}
                                                onChange={handleInputChange}
                                                className="form-select"
                                                required
                                            >
                                                {PROFESSIONS.map(({ title }) => (
                                                    <option key={title} value={title}>{title}</option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>

                                    {error && <div className="form-error">{error}</div>}

                                    <button
                                        type="submit"
                                        className="submit-button"
                                        disabled={
                                            loading ||
                                            verificationStatus !== 'verified' ||
                                            !formData.name?.trim() ||
                                            !formData.city?.trim() ||
                                            !formData.profession
                                        }
                                    >
                                        {loading ? 'Отправка...' : 'Отправить заявку'}
                                    </button>
                                </form>

                                <p className="form-note">
                                    Оставляя заявку, вы соглашаетесь на обработку персональных данных.
                                </p>
                            </>
                        ) : (
                            <div className="form-success">
                                <div className="success-icon">✓</div>
                                <h2 className="success-title">Заявка оформлена</h2>
                                <p className="success-text">
                                    Спасибо! Мы свяжемся с вами в ближайшее время.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default App;

